
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/[product]/support",
      function () {
        return require("private-next-pages/[company]/[product]/support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company]/[product]/support"])
      });
    }
  